import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class CustomValidators {
	static roleValidator(): ValidatorFn {
		return (control: AbstractControl): ValidationErrors | null => {
			const value = control.value;

			if (!value) {
				return null;
			}

			const trimmedValue = value.trim();

			if (!trimmedValue) {
				return { invalidRole: true };
			}

			if (trimmedValue.length < 2) {
				return { invalidRole: true };
			}

			if (trimmedValue.length > 100) {
				return { invalidRole: true };
			}

			if (/\s{2,}/.test(trimmedValue)) {
				return { invalidRole: true };
			}

			const roleRegex = /^[A-Za-z0-9&/-]+(?: [A-Za-z0-9&/-]+)*$/;

			if (!roleRegex.test(trimmedValue)) {
				return { invalidRole: true };
			}

			return null;
		};
	}
}